import { styled } from "styled-components";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import { theme as defaultTheme } from "@mindlercare/ui-web";
import { Typography } from "components/typography";

export const Container = styled.div`
  height: 100%;
  background: white;
  padding: 24px 32px;
  border-radius: 0px;
  @media (max-width: 759px) {
    padding: 8px 16px;
  }

  .rbc-button-link {
    background: transparent;
  }

  .rbc-time-column .rbc-timeslot-group {
    min-height: 60px;
  }

  .rbc-allday-cell {
    height: 0;
    border: none;
  }

  .rbc-time-header *,
  .rbc-time-view,
  .rbc-time-content {
    border: none;
  }
  .rbc-today {
    background-color: transparent;
  }

  .rbc-header a {
    position: relative;
    display: flex;
    justify-content: center;
    height: 100%;
  }

  .rbc-day-slot .rbc-time-slot {
    border: none;
  }

  .rbc-time-content > * + * > * {
    border-top: 1px solid ${(c) => defaultTheme.COLORS.GRAY_MEDIUM};
    border-left: 1px solid ${(c) => defaultTheme.COLORS.GRAY_MEDIUM};
  }

  .rbc-label {
    color: ${({ theme }) => defaultTheme.COLORS.GRAY_BLACK};
    font-size: ${({ theme }) => defaultTheme.FONT.SIZE.SMALL_MEDIUM};
    font-weight: ${({ theme }) => defaultTheme.FONT.WEIGHT.REGULAR};
  }

  .rbc-timeslot-group {
    border-bottom: none;

    &::first-child {
      border-left: none;
    }
  }

  .rbc-day-slot {
    &.rbc-timeslot-group:first-child {
      border-left: none;
    }

    border-left: none;
  }
  .rbc-time-header.rbc-overflowing {
    border-right: none;
  }

  .rbc-day-slot.rbc-time-column {
    &::first-child {
      border-left: none;
    }
  }

  .rbc-current-time-indicator {
    border-top: 2px solid ${(c) => defaultTheme.COLORS.GRAY_BLACK};
  }

  .rbc-time-column {
    &:nth-child(2) > div {
      border-left: none;
    }
  }
  // Hide content for defualt event wrapper
  .rbc-event-label {
    display: none;
  }
  .rbc-event {
    color: ${(c) => defaultTheme.COLORS.MIDDLE_GREY};
    border-radius: 6px;
    padding: 0;
    border: none;
    overflow: visible;
    min-height: 0;
  }

  .index__calendarContainer--1fMAc .index__event--3oRq-.index__old--2Kw4l {
    border: none;
  }

  .rbc-time-content {
    overflow: visible;
  }
  .rbc-time-header {
    margin-bottom: 4px;
  }
  .rbc-addons-dnd-row-body {
    display: none;
  }
`;

export const AlertDialog = styled(Dialog)`
  font-size: 1.625rem;
`;

export const CancelButton = styled(Button)`
  margin-right: 10px;
  &:hover {
    background: none;
  }
`;

export const DialogTitleText = styled(Typography)`
  margin-bottom: 24px;
`;

export const AlertDialogInnerContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 40px;
  width: auto;
  max-width: 800px;
  flex-direction: column;
  height: 174px;
  text-align: center;
`;

export const EventTitle = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 2px;
  font-size: 12px;
  overflow: hidden;
`;

export const ButtonDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
`;

export const ButtonSeparator = styled.div`
  margin-left: 10px;
`;

export const EventPatientTitle = styled.div`
  display: flex;
  p {
    margin: 0;
    white-space: nowrap;
  }

  p:first-of-type {
    padding-right: 4px;
  }
`;

export const CalendarContainer = styled.div`
  height: 100%;
  padding-top: 8px;
`;

export const Icon = styled.div`
  display: block;
`;

export const ActionButton = styled.button`
  margin: auto;
`;
